var styleDataHash = "d4a446e4";
const injectCss = () => {
  var css = `.-SYGF{display:inline-block;height:23px;opacity:.6;position:relative;width:45px}.-SYGF:hover{opacity:1}[dir] .-SYGF:hover{cursor:pointer}.MraRD{opacity:1}.MraRD:hover{opacity:.6}.-aWyQ{display:flex;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}[dir=ltr] .-aWyQ{margin-left:auto}[dir=rtl] .-aWyQ{margin-right:auto}.pODPt{align-items:center;display:flex;height:100%;pointer-events:none;position:absolute;top:0;width:100%}[dir=ltr] .pODPt{left:0}[dir=rtl] .pODPt{right:0}.MGLns{flex:1;height:100%}[dir] .MGLns{background-color:rgba(0,0,0,.6);border-radius:12px}[dir] .XJOCh{background-color:var(--ricos-settings-action-color,var(--ricos-action-color,#116dff))}.MGLns svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.NkO1g{height:21px;position:absolute;transition:transform .3s;width:22px}[dir] .NkO1g{background-color:#fff;border-radius:50%}[dir=ltr] .jE-Ob{transform:translateX(22px)}[dir=rtl] .jE-Ob{transform:translateX(-22px)}[dir=ltr] .MIt-r{transform:translateX(1px)}[dir=rtl] .MIt-r{transform:translateX(-1px)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var toggle_default = {
  "toggle_input_container": "-SYGF",
  "toggle_input_container_checked": "MraRD",
  "toggle_input_root": "-aWyQ",
  "toggle_switch": "pODPt",
  "toggle_track": "MGLns",
  "toggle_track_checked": "XJOCh",
  "toggle_slider": "NkO1g",
  "toggle_slider_checked": "jE-Ob",
  "toggle_slider_unchecked": "MIt-r"
};
export {
  toggle_default as default,
  injectCss
};
//# sourceMappingURL=toggle-scss.js.map
